import {Component} from '@angular/core'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {MatError, MatFormField, MatLabel, MatSuffix} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {MatInput} from '@angular/material/input'
import {BaseComponent} from '../base.component'

@Component({
  selector: 'spb-employer',
  imports: [
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    FormsModule,
    MatError,
    MatIcon,
    MatSuffix
  ],
  templateUrl: './employer.component.html',
  providers: [{provide: BaseComponent, useExisting: EmployerComponent}]
})
export class EmployerComponent extends BaseComponent {
  public override debugName = 'employer'
}
